import {
  createApiClient,
  type PlatformDataClient,
  type PlatformSession,
} from "@taunggyi-plus/api-client";

export interface BrowserAuthConfig {
  readonly apiBaseUrl: string;
  readonly appId?: string;
}

const legacyKey = "taunggyi-link-session";
const storageKey = (appId?: string) => (appId ? `${legacyKey}:${appId}` : legacyKey);

export function readBrowserSession(appId?: string): PlatformSession | null {
  try {
    const sessionKey = storageKey(appId);
    const raw = window.localStorage.getItem(sessionKey) ?? window.localStorage.getItem(legacyKey);
    if (!raw) return null;
    const session = JSON.parse(raw) as PlatformSession;
    if (
      typeof session.access_token !== "string" ||
      !session.access_token ||
      !Number.isFinite(session.expires_at) ||
      session.expires_at <= Math.floor(Date.now() / 1000) ||
      !session.user ||
      typeof session.user.id !== "string"
    ) {
      window.localStorage.removeItem(sessionKey);
      return null;
    }
    return session;
  } catch {
    return null;
  }
}

export function writeBrowserSession(session: PlatformSession | null, appId?: string) {
  const sessionKey = storageKey(appId);
  if (appId) window.localStorage.removeItem(legacyKey);
  if (session) window.localStorage.setItem(sessionKey, JSON.stringify(session));
  else window.localStorage.removeItem(sessionKey);
}

export function getBrowserAuthClient(config: BrowserAuthConfig) {
  const api = createApiClient(
    config.apiBaseUrl,
    async () => readBrowserSession(config.appId)?.access_token ?? null,
  );
  return { api, dataClient: api.dataClient as PlatformDataClient };
}

export function isAuthConfigured(config: Partial<BrowserAuthConfig>): config is BrowserAuthConfig {
  return Boolean(config.apiBaseUrl);
}
